import { mdiContentCopy } from '@mdi/js'
import Icon from '@mdi/react'

import { IconButton, type IIconButtonProps } from '@/components/ui/button'

const Copy = ({
    message,
    itemId,
    itemHtml,
    callback,
    className,
    size,
    minW,
    iconMarginRight,
}: {
    message: string | null
    className?: string
    itemHtml?: string
    itemId?: number | null
    size?: string
    minW?: IIconButtonProps['minW']
    iconMarginRight?: string
    callback?: () => void
}) => {
    const copyToClipboard = () => {
        try {
            let htmlCode = itemId ? document.getElementById(itemId.toString())?.innerHTML : ''
            if (itemHtml) {
                htmlCode = itemHtml
            }
            const data = [
                new ClipboardItem({
                    'text/plain': new Blob([message || ''], { type: 'text/plain' }),
                    'text/html': new Blob([htmlCode || ''], { type: 'text/html' }),
                }),
            ]

            void navigator.clipboard.write(data).then(() => {
                callback?.()
            })
        } catch (error) {
            console.error('Failed to copy content to clipboard: ', error)
        }
    }

    return (
        message && (
            <IconButton
                aria-label="Copy"
                icon={<Icon path={mdiContentCopy} size={size || 1} />}
                onClick={copyToClipboard}
                variant="copy"
                mr={iconMarginRight || '12px'}
                data-id="chat-reply-copy"
                className={className}
                data-testid="chat-actions-copy-button"
                minW={minW || '40px'}
                rounded="full"
            />
        )
    )
}

export default Copy
